import { auth } from '../config';
import { captureAsyncError } from '../../../utils/errorHandler';

/**
 * FE→Storage→result作成後にFunctionsに送るファイル情報
 */
export interface ClassificationFileInfo {
  filePath: string;
  fileName: string;
  fileSize: number;
  fileType: string;
  pageCount: number;
}

/**
 * JSON形式の仕分けリクエスト
 */
export interface ClassifyDocumentsJsonRequest {
  filePaths: ClassificationFileInfo[];
  resultIds: string[];
  processingType: number;
  geminiModel?: number;
  isProxy?: boolean;
  operatorId?: string;
  proxyCompanyId?: string;
  provisionalDeducted?: boolean;
  feProvisionalCreditAmount?: number;
  // 仮加算（current_month_ocr_cost）に +15円 が乗ったか。
  // 仕分け経路は仕分け前のため常に false。BEの確定 delta 計算に渡す。
  provisionalHasMasterMapping?: boolean;
  // クレジット仮引きで「超過側」として扱ったページ数の真値（#3052 リグレッション修正 / PR#3065）。
  // BEがファイル間配分の境界に使う。額を単価で逆算（round）すると端数円が消失するため真値を渡す。
  provisionalExcessPages?: number;
}

/**
 * 書類仕分け関数を呼び出し（JSON形式）
 * FE側でStorage upload + result作成を完了後、Storageパスのみ送信する
 * レスポンスは待たない（fire-and-forget）
 */
export const classifyDocumentsJson = captureAsyncError(
  async (request: ClassifyDocumentsJsonRequest): Promise<void> => {
    if (!auth.currentUser) {
      throw new Error('ユーザーがログインしていません。');
    }

    const token = await auth.currentUser.getIdToken();

    const baseUrl = process.env.REACT_APP_FUNCTION_URL;
    if (!baseUrl) {
      throw new Error('REACT_APP_FUNCTION_URLが設定されていません。');
    }
    const functionUrl = `${baseUrl}/classifyDocuments`;

    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      let errorMessage = '書類の仕分けに失敗しました。もう一度お試しください。';
      try {
        const errorData = await response.json();
        if (errorData?.error) {
          errorMessage = errorData.error;
        }
      } catch {
        // JSONパース失敗時はデフォルトメッセージを使用
      }
      throw new Error(errorMessage);
    }
  },
);
